import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const crisp = defineConnector({
  identifier: "crisp",
  name: "Crisp",
  tagLine: "Customer messaging platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.crisp\\.chat/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.tokenId,
      password: app.secret.tokenKey,
    }).withHeaders([
      {
        name: "X-Crisp-Tier",
        value: "plugin",
      },
    ]),
  steps: [
    {
      title: "Get your Crisp API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In Crisp, go to **Settings > Website settings > Tokens** to generate an API token identifier and key pair.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Token identifier",
          required: true,
          target: { kind: "configuration", field: "tokenId" },
        },
        {
          kind: "input",
          label: "Token key",
          required: true,
          target: { kind: "secrets", field: "tokenKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.crisp.chat/v1/website",
  },
});
